<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer055">
<p class="structure-nxt" id="calibre_pb_7"> </p>
<p class="body-text">This book is dedicated to my mother, who has always been my biggest supporter, and told me to never give up on my dreams. I love you,<span> </span>Mom.</p>
<p class="body-text">I would also like to thank all the wonderful participants who created postcards and submitted their manifestation stories to me. This book wouldn’t exist without you. You each are my<span> </span>inspiration.</p>
<p class="body-text">Also, dedicated to Wayne Dyer, who has always been a huge influence in my life, and whom I had the pleasure of meeting a couple of years before he passed away. Below is his signature on a note where I wrote the words, Postcards to the Universe, when this book was still just a vision in my<span> </span>head.</p>
<p class="body-text"> </p>
<p class="basic-paragraph" id="calibre_pb_8" xml:lang="en-GB"><img alt="" class="_idgenobjectattribute2" src="OEBPS/image/_1_-_Dedication_Wayne_Dyer_Signature.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ebook_split_005.vue?62f53346